module.exports = __webpack_public_path__ + "static/media/no-photo.c26094d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Projects/no-photo.svg
// module id = 1465
// module chunks = 2